<template>
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.64265 5.2067L8.84565 3.02884L8.86229 13.7006C8.86229 14.3491 9.39429 14.8748 10.0505 14.8748C10.7068 14.8748 11.2388 14.3491 11.2388 13.7006L11.2221 3.04217L13.4125 5.20674C13.8684 5.67321 14.6206 5.68613 15.0927 5.23558C15.5647 4.78503 15.5778 4.04165 15.1218 3.57517C15.1123 3.56537 15.1025 3.55576 15.0927 3.54633L12.5482 1.03183C11.1561 -0.343936 8.89905 -0.343936 7.50691 1.03179L7.50687 1.03183L4.96247 3.54629C4.50656 4.01277 4.51963 4.75615 4.99166 5.2067C5.45214 5.64621 6.18217 5.64621 6.64265 5.2067Z"
      fill="currentColor"
    />
    <path
      d="M18.3178 11.3525C17.6616 11.3525 17.1296 11.8783 17.1296 12.5268V16.1208C17.1291 16.2975 16.9843 16.4406 16.8056 16.441H3.19461C3.01585 16.4406 2.87104 16.2975 2.87063 16.1208V12.5268C2.87063 11.8783 2.33863 11.3525 1.68238 11.3525C1.02614 11.3525 0.494141 11.8783 0.494141 12.5268V16.1208C0.495886 17.594 1.70392 18.7878 3.19461 18.7895H16.8055C18.2963 18.7878 19.5043 17.594 19.506 16.1208V12.5268C19.506 11.8783 18.974 11.3525 18.3178 11.3525Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconUpload'
}
</script>
